import React, { ReactNode } from "react";
import FamilyImage from "../../assets/consult/consult-family-illustration.png";
import { css, StyleSheet } from "aphrodite";
import Text from "../core/Text";
import Flex from "../core/Flex";
import useCareScreenerWidth from "../../hooks/care-screener/useCareScreenerWidth";
import CreateYourAccount from "./insurance/CreateYourAccount";

type Props = {
  onPasswordSubmitted: (value: string | undefined) => Promise<void>;
  consultPath: string;
  progressComponent?: ReactNode;
};

function Spacer({ height = 20 }: { height?: number }) {
  return <div style={{ marginTop: height }} />;
}

export default function CareScreenerPasswordInput({ onPasswordSubmitted, consultPath, progressComponent }: Props) {
  const { widthStyle } = useCareScreenerWidth();

  return (
    <Flex className={css(styles.container)} style={widthStyle}>
      {progressComponent}
      <div className={css(styles.columnCentered)}>
        <img src={FamilyImage} className={css(styles.image)} />
        <Text style={styles.title} theme="manaBlueDark" title size={24}>
          Let's get you care!
        </Text>
        <Spacer height={20} />
        <CreateYourAccount
          onPasswordSubmitted={onPasswordSubmitted}
          subttitleText="to save your progress, and match with a provider!"
          consultPath={consultPath}
        />
      </div>
    </Flex>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: 50,
    marginBottom: 50,
    padding: "5%",
    paddingTop: 10,
    backgroundColor: "#FFFFFF",
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: 15
  },
  columnCentered: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  image: {
    width: 300,
    height: 150,
    minHeight: 160,
    objectFit: "contain",
    aspectRatio: 1,
    marginTop: 20,
    marginBottom: 10
  },
  title: {
    textAlign: "center",
    marginBottom: 10,
    marginTop: 20
  }
});
